var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconControlPanelDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #333;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.91,171.61c-.48-.65-11.92-16.07-31.06-31.66-25.62-20.87-52.87-31.9-78.89-31.9s-53.19,11.03-78.81,31.9c-19.14,15.59-30.58,31.02-31.06,31.66-.71,.96-1.09,2.12-1.09,3.31v.15c0,1.19,.38,2.35,1.09,3.31,.48,.65,11.92,16.07,31.06,31.66,25.62,20.87,52.87,31.9,78.89,31.9s53.19-11.03,78.81-31.9c19.14-15.59,30.58-31.02,31.06-31.66,.71-.96,1.09-2.12,1.09-3.31v-.15c0-1.19-.38-2.35-1.09-3.31Zm-109.95,59.16c-48.84,0-88.11-43.41-98.3-55.77,10.19-12.36,49.46-55.77,98.37-55.77s88.11,43.42,98.3,55.77c-10.19,12.36-49.46,55.77-98.37,55.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175,139.66c-19.49,0-35.34,15.86-35.34,35.34s15.86,35.34,35.34,35.34,35.34-15.86,35.34-35.34-15.86-35.34-35.34-35.34Zm0,58.91c-12.99,0-23.56-10.57-23.56-23.56s10.57-23.56,23.56-23.56,23.56,10.57,23.56,23.56-10.57,23.56-23.56,23.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControlPanelDetail);
export default __webpack_public_path__ + "static/media/icon-control-panel-detail.1b3a60447356d246221709a21850197d.svg";
export { ForwardRef as ReactComponent };